/**
 * Account General Info Form Options
 * Provides translated option sets for form dropdowns
 */

// Company type options - synchronized with KYC Legal Forms
export const getCompanyTypeOptions = (t: (key: string) => string) => [
  {
    value: 'einzelunternehmen',
    label: t('accountGeneralInfo.companyTypes.einzelunternehmen'),
  },
  {
    value: 'einfache_gesellschaft',
    label: t('accountGeneralInfo.companyTypes.einfache_gesellschaft'),
  },
  {
    value: 'kollektivgesellschaft',
    label: t('accountGeneralInfo.companyTypes.kollektivgesellschaft'),
  },
  {
    value: 'ag',
    label: t('accountGeneralInfo.companyTypes.ag'),
  },
  {
    value: 'gmbh',
    label: t('accountGeneralInfo.companyTypes.gmbh'),
  },
  {
    value: 'oeffentlich_rechtliche_institution',
    label: t(
      'accountGeneralInfo.companyTypes.oeffentlich_rechtliche_institution'
    ),
  },
  {
    value: 'kommanditaktiengesellschaft',
    label: t('accountGeneralInfo.companyTypes.kommanditaktiengesellschaft'),
  },
  {
    value: 'kommanditgesellschaft',
    label: t('accountGeneralInfo.companyTypes.kommanditgesellschaft'),
  },
  {
    value: 'verein',
    label: t('accountGeneralInfo.companyTypes.verein'),
  },
  {
    value: 'stiftung',
    label: t('accountGeneralInfo.companyTypes.stiftung'),
  },
  {
    value: 'genossenschaft',
    label: t('accountGeneralInfo.companyTypes.genossenschaft'),
  },
  {
    value: 'other',
    label: t('accountGeneralInfo.companyTypes.other'),
  },
];

// Language options
export const getLanguageOptions = (t: (key: string) => string) => [
  {
    value: 'de',
    label: t('languages.de'),
  },
  {
    value: 'en',
    label: t('languages.en'),
  },
  {
    value: 'fr',
    label: t('languages.fr'),
  },
  {
    value: 'it',
    label: t('languages.it'),
  },
];

// Industry options
export const getIndustryOptions = (t: (key: string) => string) => [
  {
    value: 'technology',
    label: t('industries.technology'),
  },
  {
    value: 'finance',
    label: t('industries.finance'),
  },
  {
    value: 'healthcare',
    label: t('industries.healthcare'),
  },
  {
    value: 'manufacturing',
    label: t('industries.manufacturing'),
  },
  {
    value: 'retail',
    label: t('industries.retail'),
  },
  {
    value: 'consulting',
    label: t('industries.consulting'),
  },
  {
    value: 'real_estate',
    label: t('industries.realEstate'),
  },
  {
    value: 'construction',
    label: t('industries.construction'),
  },
  {
    value: 'education',
    label: t('industries.education'),
  },
  {
    value: 'transportation',
    label: t('industries.transportation'),
  },
  {
    value: 'agriculture',
    label: t('industries.agriculture'),
  },
  {
    value: 'hospitality',
    label: t('industries.hospitality'),
  },
  {
    value: 'other',
    label: t('industries.other'),
  },
];

// Canton options (Swiss specific)
export const getCantonOptions = (t: (key: string) => string) => [
  {
    value: 'ZH',
    label: t('cantons.zurich'),
  },
  {
    value: 'BE',
    label: t('cantons.bern'),
  },
  {
    value: 'LU',
    label: t('cantons.lucerne'),
  },
  {
    value: 'UR',
    label: t('cantons.uri'),
  },
  {
    value: 'SZ',
    label: t('cantons.schwyz'),
  },
  {
    value: 'OW',
    label: t('cantons.obwalden'),
  },
  {
    value: 'NW',
    label: t('cantons.nidwalden'),
  },
  {
    value: 'GL',
    label: t('cantons.glarus'),
  },
  {
    value: 'ZG',
    label: t('cantons.zug'),
  },
  {
    value: 'FR',
    label: t('cantons.fribourg'),
  },
  {
    value: 'SO',
    label: t('cantons.solothurn'),
  },
  {
    value: 'BS',
    label: t('cantons.baselStadt'),
  },
  {
    value: 'BL',
    label: t('cantons.baselLandschaft'),
  },
  {
    value: 'SH',
    label: t('cantons.schaffhausen'),
  },
  {
    value: 'AR',
    label: t('cantons.appenzellAusserrhoden'),
  },
  {
    value: 'AI',
    label: t('cantons.appenzellInnerrhoden'),
  },
  {
    value: 'SG',
    label: t('cantons.stGallen'),
  },
  {
    value: 'GR',
    label: t('cantons.grisons'),
  },
  {
    value: 'AG',
    label: t('cantons.aargau'),
  },
  {
    value: 'TG',
    label: t('cantons.thurgau'),
  },
  {
    value: 'TI',
    label: t('cantons.ticino'),
  },
  {
    value: 'VD',
    label: t('cantons.vaud'),
  },
  {
    value: 'VS',
    label: t('cantons.valais'),
  },
  {
    value: 'NE',
    label: t('cantons.neuchatel'),
  },
  {
    value: 'GE',
    label: t('cantons.geneva'),
  },
  {
    value: 'JU',
    label: t('cantons.jura'),
  },
];
